export const PARISH_NAME = process.env.REACT_APP_PARISH_NAME || 'Project Jerusalem'
export const TIMEZONE = process.env.REACT_APP_TIMEZONE || 'Asia/Jerusalem'
console.log("Loaded PARISH_NAME:", process.env.REACT_APP_PARISH_NAME)
